import styled from 'styled-components';

const CaseStudyStyle = styled.div`
  .header-content {
    display: flex;
    justify-content: space-between;
    .title {
      color: #0c3255;
    }
  }
  .content {
    border: 1px solid #0c3255;
    border-radius: 5px;
    padding: 10px;
    .total-box {
      font-weight: 600;
      font-size: 16px;
      margin-right: 20px;
    } 
    .filter-box {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      align-items: center;
      .search-box {
        display: flex;
        .ant-input-affix-wrapper {
          .ant-input-prefix {
            color: #342c24;
          }
          border: 1px solid #342c24;
          .ant-input {
            color: #000000;
          }
        }
      }
    }
    .data-table {
      margin-top: 30px;
      height: calc(100vh - 300px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .langue-select {
      display: flex;
      gap: 20px;
      align-items: center;
    }
  }
`;

export default CaseStudyStyle;
